<template>
  <div class="card">
    <div class="card-header">
      <h4>Configurações da replicação</h4>
    </div>
    <div class="card-content">
      <div class="form-group">
        <label>Host do servidor remoto:</label>
        <input
          class="form-control"
          type="text"
          :value="project.remoteHost"
        >
      </div>
      <div class="form-group">
        <label>Prefixo do banco:</label>
        <select
          class="form-control"
          v-model="project.projectName"
          name="label-projeto"
          id=""
        >
          <option
            v-for="label in projectsNames"
            :value="label"
          >{{label}}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'RemoteConfigForm',

    computed: {
      ...mapGetters('project', ['projectsNames']),
      project: {
        get () {
          return this.$store.state.project.one
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/Project/RemoteConfigProject.vue